// GENERATED by scripts/gen-version.mjs from package.json — do not edit by hand.
// Regenerated on every build (prebuild); kept honest by version.test.ts.

/** This SDK's package version, baked from package.json at build (SP2-6). */
export const SDK_VERSION = '0.90.2';
